<script>
  export default {
    name: 'Modal',
    props: ['imageso'],
    methods: {
      close() {
        this.$emit('close');
      },
    },
    created: function () { 
        //console.log('a', this.imageso) //prints out an empty string
    },
  };
</script>

<template>
  <transition name="modal-fade"> 
    <div class="z-40 overflow-auto left-0 top-0 bottom-0 right-0 w-full h-full fixed flex items-center self-center">
      <div class="z-50 relative mx-auto py-8 px-8 w-full">
        <div class="bg-white rounded shadow-lg border flex flex-col overflow-hidden w-1/2 m-auto">
          <div class="flex flex-row border-b items-center justify-between">
            <div class="px-6 py-3 text-xl font-bold">Preview</div>
            <div class="">
              <button @click="close" class="font-3xl font-bold p-6">&times;</button>
            </div> 
          </div>
          <div class="mx-5 my-5"> 
          <img class=" m-auto" :src="this.imageso" alt="23paskal" /> 
          </div>
        </div>
      </div>
      <div @click="close" class="z-40 overflow-auto left-0 top-0 bottom-0 right-0 w-full h-full fixed bg-black opacity-50"></div>
    </div>
  </transition>
  
</template> 